import {
  getTransactionList,
  getMonthlyStatistics,
  exportTransactions,
} from "@/api/billing";
import dayjs from "dayjs";
import i18n from "@/i18n";

const state = {
  transactions: [],
  total: 0,
  loading: false,
};

const mutations = {
  SET_TRANSACTIONS: (state, { list, total }) => {
    state.transactions = list;
    state.total = total;
  },
  SET_LOADING: (state, status) => {
    state.loading = status;
  },
};

const actions = {
  // 获取交易记录列表
  getTransactions({ commit }, params) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      getTransactionList(params)
        .then((response) => {
          const { data } = response;
          const list = data.list || [];
          const total = data.total || 0;
          commit("SET_TRANSACTIONS", { list, total });
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        })
        .finally(() => {
          commit("SET_LOADING", false);
        });
    });
  },

  // 获取月度统计数据
  getMonthlyStats() {
    return getMonthlyStatistics().then((response) => {
      return response.data || {};
    });
  },

  // 导出交易记录
  async exportTransactions({ commit }, params) {
    try {
      // 获取响应数据
      const response = await exportTransactions(params);
      const base64Data = response.data;
      // 解码Base64字符串
      const binaryString = atob(base64Data);
      // 创建Uint8Array
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }
      // 创建Blob对象
      const blob = new Blob([bytes], { type: "application/vnd.ms-excel" });

      // 生成文件名
      const transactionRecords = i18n.t('billing.transactionRecords');
      const fileName =
        params.startDate && params.endDate
          ? `${transactionRecords}_${params.startDate}_${params.endDate}.csv`
          : `${transactionRecords}_${dayjs().format("YYYY-MM-DD")}.csv`;

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return Promise.resolve();
    } catch (error) {
      console.error(i18n.t('billing.exportTransactionsFailed'), error);
      return Promise.reject(
        new Error(i18n.t('billing.exportFailedPrefix') + "：" + (error.message || i18n.t('billing.unknownError')))
      );
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
